import React from 'react'
import styled from "styled-components";
import { SegmentWithRef } from '~/components/semantic'


const StyledSegment = styled(({ active, ...rest }) => <SegmentWithRef {...rest} />)`
  &.ui.segment {
    cursor: pointer;
    min-height: 80px;
    border-radius: 4px;
    margin: ${props => props.active ? '1rem 0 2rem' : '1rem 0'};
    ${props => props.active ? 'box-shadow: 0 1px 3px 0 rgba(0,0,0,0.05), 0 16px 32px 0 rgba(0,0,0,0.10);' : '' }
    ${props => props.active ? 'border: 1px solid rgba(34, 36, 38, 0.25);' : '' }
  }
`;

const Title = styled.div`
  display: flex;
`;

const Radio = styled.div`
  background: ${props => props.active ? props.theme.primary : '#FFFFFF'};
  border: 1px solid ${props => props.active ? props.theme.primary : '#D3D3D3'};
  width: 28px;
  height: 28px;
  border-radius: 14px;
  margin-right: 20px;
  margin-top: 7px;
  position: relative;
  
  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 7px;
    left: 7px;
    width: 12px;
    height: 12px;
    background: #FFF;
    border-radius: 6px;
  }
  
`;

const TitleContent = styled.div`
  flex: 1;
  display: flex;
`;


export default class SelectListItem extends React.PureComponent {
  state = {
    hover: false,
  };

  handleMouseEnter = (e) => {
    this.setState({hover: true})
  };

  handleMouseLeave = (e) => {
    this.setState({hover: false})
  };

  render() {
    const { children, active, title, ...rest} = this.props;
    const { hover } = this.state;
    return (
      <StyledSegment active={ active } raised={ active || hover } {...rest} onMouseEnter={ this.handleMouseEnter } onMouseLeave={ this.handleMouseLeave }>
        <Title>
          <Radio active={ active } />
          <TitleContent>
            { title }
          </TitleContent>
        </Title>
        <div>
          { children }
        </div>
      </StyledSegment>
    )
  }
}
